<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-if="!showAdd" class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-form inline label-position="top">
            <el-form-item>
              <el-input v-model="listQuery.machId" placeholder="商户号"/>
            </el-form-item>
            <el-form-item>
              <el-input v-model="listQuery.machName" placeholder="商户名称"/>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="listQuery.ExpiredTime" placeholder="过期时间"/>
            </el-form-item> -->
            <el-form-item>
              <el-select v-model="listQuery.state">
                <el-option value="A" label="启用"/>
                <el-option value="S" label="禁用"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                v-waves
                round
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
              >{{ $t('table.search') }}</el-button>
              <el-button
                v-if="calcPermission(permition, 1)"
                round
                class="filter-item"
                type="danger"
                icon="el-icon-circle-plus-outline"
                @click="hanldeAdd()"
              >{{ $t('table.add') }}</el-button>
            </el-form-item>
          </el-form>

        </el-card>

      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-if="!showAdd" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"
          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商户号" prop="MachId" align="center"/>
          <el-table-column label="商户名称" prop="MachName" align="center"/>
          <el-table-column label="商户支付密钥" prop="Paysignkey" align="center"/>
          <el-table-column label="过期时间" prop="ExpiredTime" align="center"/>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link type="primary" @click="hanldeAdd(scope.row)">编辑</el-link>

              <el-link v-if="scope.row.StatusNo === 'A'" type="danger" @click="handleSwitch(scope.row)">禁用</el-link>
              <el-link v-else type="primary" @click="handleSwitch(scope.row)">启用</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>
    <transition name="el-zoom-in-bottom">

      <create-form
        v-if="showAdd"
        ref="createForm"
        @refresh="getList"
        @close="showAdd = false"
      />
    </transition>

  </div>
</template>
<script>
import { qryMachInfo, updateMachState } from './api'
import { qryRoleInfo } from '@/api/baseModule'
// import { parseTime } from '@/utils'
import waves from '@/directive/waves' // 水波纹指令
import CreateForm from './form.vue'
export default {
  name: 'ShopManage',
  components: {
    CreateForm
  },
  directives: {
    waves
  },
  filters: {
  },
  data() {
    return {
      showAdd: false,
      refundVisible: false,
      splitOrderData: [],
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        machId: undefined,
        machName: undefined,
        state: undefined
      },
      listLoading: true,
      list: [],
      permition: 0,
      total: null,

      TotalMoney: 0,
      VirtualMoney: 0,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      downloadLoading: false,
      roleId: null,
      url_: process.env.BASE_API
    }
  },
  watch: {
    listQuery: {
      handler(value) {
        console.log(value)
        for (const key in value) {
          if (!value[key]) {
            value[key] = null
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.roleId = this.$store.getters.roles.RoleId
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getList()
        }
      })
      // this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
      //   if (this.$route.path === item.ProgramInfo.PgUrl) {
      //     this.permition = item.Permition
      //     this.getList()
      //   }
      // })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getList()
          }
        })
      })
    }
  },
  methods: {
    // 启用禁用
    handleSwitch(row) {
      this.$confirm('确定进行此操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateMachState({
          maId: row.MaId,
          state: row.StatusNo === 'A' ? 'S' : 'A'
        }).then(res => {
          this.$message.success('操作成功')
          this.getList()
        })
      }).catch(() => {})
    },
    hanldeAdd(record) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.createForm.init(record)
      })
    },
    // 获取场地列表
    getList() {
      qryMachInfo(this.listQuery).then(request => {
        console.log(request)
        this.list = request.LsList
        this.total = request.TotalRows
        this.listLoading = false
        console.log(request.LsList)
      })
    },
    // 退款订单列表
    handleRefund(item) {
      console.log(item)
      this.getRefundList(item, 1)
      this.refundVisible = true
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.getList()
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      // this.listQuery.name = this.listQuery.key
      this.getList()
    },
    refund() {
      alert('暂不支持退款')
    }
  }
}
</script>
<style lang="less" scoped>
.custom-width{
  width: 100%;
}
</style>
